import * as React from 'react';
import { Popup } from '@rc-component/tooltip';
import { isReactRenderable } from '@rc-component/util';
import { clsx } from 'clsx';
import { getRenderPropValue } from '../_util/getRenderPropValue';
import { useMergeSemantic } from '../_util/hooks/useMergeSemantic';
import { ConfigContext } from '../config-provider';
import useStyle from './style';
export const Overlay = (props) => {
    const { title, content, prefixCls, classNames, styles } = props;
    if (!isReactRenderable(title) && !isReactRenderable(content)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        isReactRenderable(title) && (React.createElement("div", { className: clsx(`${prefixCls}-title`, classNames?.title), style: styles?.title }, title)),
        isReactRenderable(content) && (React.createElement("div", { className: clsx(`${prefixCls}-content`, classNames?.content), style: styles?.content }, content))));
};
export const RawPurePanel = (props) => {
    const { hashId, prefixCls, className, style, placement = 'top', title, content, children, classNames, styles, } = props;
    const titleNode = getRenderPropValue(title);
    const contentNode = getRenderPropValue(content);
    const mergedProps = {
        ...props,
        placement,
    };
    const [mergedClassNames, mergedStyles] = useMergeSemantic([classNames], [styles], {
        props: mergedProps,
    });
    const rootClassName = clsx(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return (React.createElement("div", { className: rootClassName, style: style },
        React.createElement("div", { className: `${prefixCls}-arrow` }),
        React.createElement(Popup, { ...props, className: hashId, prefixCls: prefixCls, classNames: mergedClassNames, styles: mergedStyles }, children || (React.createElement(Overlay, { prefixCls: prefixCls, title: titleNode, content: contentNode, classNames: mergedClassNames, styles: mergedStyles })))));
};
const PurePanel = (props) => {
    const { prefixCls: customizePrefixCls, className, ...restProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = useStyle(prefixCls);
    return (React.createElement(RawPurePanel, { ...restProps, prefixCls: prefixCls, hashId: hashId, className: clsx(className, cssVarCls) }));
};
export default PurePanel;
